export default {"src":"/_next/static/media/gov-document.1b99a946.svg","height":160,"width":175,"blurWidth":0,"blurHeight":0};